const Icon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9943 7.54492V14.3796L15.0394 11.114L14.0859 7.54492H15.9943Z"
      fill="#CB9AFF"
    />
    <path
      d="M11.6875 7.54492L15.0415 11.114L14.088 7.54492H11.6875Z"
      fill="#B68DFF"
    />
    <path
      d="M12.6432 11.0418L11.6868 7.54492H9.51172L12.6432 11.0418Z"
      fill="#8A73FF"
    />
    <path
      d="M12.6439 11.0418L11.6875 7.54492L15.0415 11.114L15.9964 14.3796L12.6439 11.0418Z"
      fill="#A180FF"
    />
    <path
      d="M17.9035 7.54492L16.95 11.114L15.9951 14.3796V7.54492H17.9035Z"
      fill="#B68DFF"
    />
    <path
      d="M20.3042 7.54492L16.9502 11.114L17.9036 7.54492H20.3042Z"
      fill="#A180FF"
    />
    <path
      d="M19.3477 11.0418L20.304 7.54492H22.4791L19.3477 11.0418Z"
      fill="#785EF7"
    />
    <path
      d="M19.3476 11.0418L20.304 7.54492L16.95 11.114L15.9951 14.3796L19.3476 11.0418Z"
      fill="#8A73FF"
    />
    <path
      d="M15.9943 7.54492V0.710266L15.0394 3.97581L14.0859 7.54492H15.9943Z"
      fill="#EABFFF"
    />
    <path
      d="M14.088 7.54494L15.0415 3.97583L11.6875 7.54494H14.088Z"
      fill="#CB9AFF"
    />
    <path
      d="M9.51172 7.54491H11.6868L12.6432 4.048L9.51172 7.54491Z"
      fill="#A180FF"
    />
    <path
      d="M15.9964 0.710266L15.0415 3.97581L11.6875 7.54492L12.6439 4.04802L15.9964 0.710266Z"
      fill="#B68DFF"
    />
    <path
      d="M17.9035 7.54492L16.95 3.97581L15.9951 0.710266V7.54492H17.9035Z"
      fill="#CB9AFF"
    />
    <path
      d="M17.9036 7.54494L16.9502 3.97583L20.3042 7.54494H17.9036Z"
      fill="#B68DFF"
    />
    <path
      d="M22.4791 7.54491H20.304L19.3477 4.048L22.4791 7.54491Z"
      fill="#8A73FF"
    />
    <path
      d="M15.9951 0.710266L16.95 3.97581L20.304 7.54492L19.3476 4.04802L15.9951 0.710266Z"
      fill="#A180FF"
    />
    <path
      d="M19.3322 5.77659C19.0272 5.70733 18.7885 5.46713 18.7192 5.16356C18.7133 5.13999 18.6839 5.13999 18.678 5.16356C18.6087 5.4686 18.3685 5.70733 18.0649 5.77659C18.0414 5.78248 18.0414 5.81196 18.0649 5.81785C18.37 5.88711 18.6087 6.12731 18.678 6.43088C18.6839 6.45446 18.7133 6.45446 18.7192 6.43088C18.7885 6.12584 19.0287 5.88711 19.3322 5.81785C19.3544 5.81196 19.3544 5.78101 19.3322 5.77659ZM17.5492 4.04803C17.3104 3.98614 17.1218 3.79752 17.0599 3.55879C17.054 3.53521 17.0231 3.53521 17.0157 3.55879C16.9538 3.79752 16.7652 3.98614 16.5265 4.04803C16.5029 4.05393 16.5029 4.08487 16.5265 4.09224C16.7652 4.15413 16.9538 4.34276 17.0157 4.58148C17.0216 4.60506 17.0526 4.60506 17.0599 4.58148C17.1218 4.34276 17.3104 4.15413 17.5492 4.09224C17.5727 4.08487 17.5727 4.05393 17.5492 4.04803Z"
      fill="white"
    />
    <g clipPath="url(#clip0_1106_1161)">
      <path
        d="M15.9943 24.4456V31.2803L15.0394 28.0147L14.0859 24.4456H15.9943Z"
        fill="#CB9AFF"
      />
      <path
        d="M11.6875 24.4456L15.0415 28.0147L14.088 24.4456H11.6875Z"
        fill="#B68DFF"
      />
      <path
        d="M12.6432 27.9425L11.6868 24.4456H9.51172L12.6432 27.9425Z"
        fill="#8A73FF"
      />
      <path
        d="M12.6439 27.9425L11.6875 24.4456L15.0415 28.0147L15.9964 31.2803L12.6439 27.9425Z"
        fill="#A180FF"
      />
      <path
        d="M17.9035 24.4456L16.95 28.0147L15.9951 31.2803V24.4456H17.9035Z"
        fill="#B68DFF"
      />
      <path
        d="M20.3042 24.4456L16.9502 28.0147L17.9036 24.4456H20.3042Z"
        fill="#A180FF"
      />
      <path
        d="M19.3477 27.9425L20.304 24.4456H22.4791L19.3477 27.9425Z"
        fill="#785EF7"
      />
      <path
        d="M19.3476 27.9425L20.304 24.4456L16.95 28.0147L15.9951 31.2803L19.3476 27.9425Z"
        fill="#8A73FF"
      />
      <path
        d="M15.9943 24.4456V17.6109L15.0394 20.8765L14.0859 24.4456H15.9943Z"
        fill="#EABFFF"
      />
      <path
        d="M14.088 24.4456L15.0415 20.8765L11.6875 24.4456H14.088Z"
        fill="#CB9AFF"
      />
      <path
        d="M9.51172 24.4456H11.6868L12.6432 20.9487L9.51172 24.4456Z"
        fill="#A180FF"
      />
      <path
        d="M15.9964 17.6109L15.0415 20.8765L11.6875 24.4456L12.6439 20.9487L15.9964 17.6109Z"
        fill="#B68DFF"
      />
      <path
        d="M17.9035 24.4456L16.95 20.8765L15.9951 17.6109V24.4456H17.9035Z"
        fill="#CB9AFF"
      />
      <path
        d="M17.9036 24.4456L16.9502 20.8765L20.3042 24.4456H17.9036Z"
        fill="#B68DFF"
      />
      <path
        d="M22.4791 24.4456H20.304L19.3477 20.9487L22.4791 24.4456Z"
        fill="#8A73FF"
      />
      <path
        d="M15.9951 17.6109L16.95 20.8765L20.304 24.4456L19.3476 20.9487L15.9951 17.6109Z"
        fill="#A180FF"
      />
      <path
        d="M19.3322 22.6773C19.0272 22.608 18.7885 22.3678 18.7192 22.0642C18.7133 22.0407 18.6839 22.0407 18.678 22.0642C18.6087 22.3693 18.3685 22.608 18.0649 22.6773C18.0414 22.6831 18.0414 22.7126 18.0649 22.7185C18.37 22.7878 18.6087 23.028 18.678 23.3315C18.6839 23.3551 18.7133 23.3551 18.7192 23.3315C18.7885 23.0265 19.0287 22.7878 19.3322 22.7185C19.3544 22.7126 19.3544 22.6817 19.3322 22.6773ZM17.5492 20.9487C17.3104 20.8868 17.1218 20.6982 17.0599 20.4595C17.054 20.4359 17.0231 20.4359 17.0157 20.4595C16.9538 20.6982 16.7652 20.8868 16.5265 20.9487C16.5029 20.9546 16.5029 20.9855 16.5265 20.9929C16.7652 21.0548 16.9538 21.2434 17.0157 21.4821C17.0216 21.5057 17.0526 21.5057 17.0599 21.4821C17.1218 21.2434 17.3104 21.0548 17.5492 20.9929C17.5727 20.9855 17.5727 20.9546 17.5492 20.9487Z"
        fill="white"
      />
    </g>
    <path
      d="M24.4501 16.0002L24.4545 22.8349L25.4073 19.5687L26.3584 15.999L24.4501 16.0002Z"
      fill="#CB9AFF"
    />
    <path
      d="M28.7588 15.9974L25.4072 19.5687L26.3583 15.999L28.7588 15.9974Z"
      fill="#B68DFF"
    />
    <path
      d="M27.8044 19.4949L28.7585 15.9974L30.9336 15.9959L27.8044 19.4949Z"
      fill="#8A73FF"
    />
    <path
      d="M27.8047 19.4949L28.7588 15.9974L25.4072 19.5687L24.4544 22.8349L27.8047 19.4949Z"
      fill="#A180FF"
    />
    <path
      d="M22.5419 16.0015L23.4976 19.5699L24.4547 22.8349L24.4502 16.0002L22.5419 16.0015Z"
      fill="#B68DFF"
    />
    <path
      d="M20.1402 16.0031L23.4965 19.57L22.5407 16.0015L20.1402 16.0031Z"
      fill="#A180FF"
    />
    <path
      d="M21.1 19.4993L20.1413 16.003L17.9662 16.0045L21.1 19.4993Z"
      fill="#785EF7"
    />
    <path
      d="M21.1 19.4993L20.1413 16.003L23.4976 19.5699L24.4547 22.8349L21.1 19.4993Z"
      fill="#8A73FF"
    />
    <path
      d="M24.4497 16.0002L24.4452 9.16556L25.4022 12.4305L26.358 15.999L24.4497 16.0002Z"
      fill="#EABFFF"
    />
    <path
      d="M26.3587 15.999L25.4029 12.4305L28.7592 15.9974L26.3587 15.999Z"
      fill="#CB9AFF"
    />
    <path
      d="M30.9349 15.996L28.7599 15.9974L27.8012 12.5011L30.9349 15.996Z"
      fill="#A180FF"
    />
    <path
      d="M24.446 9.16555L25.4031 12.4305L28.7594 15.9974L27.8007 12.5011L24.446 9.16555Z"
      fill="#B68DFF"
    />
    <path
      d="M22.5415 16.0015L23.4926 12.4317L24.4453 9.16556L24.4498 16.0002L22.5415 16.0015Z"
      fill="#CB9AFF"
    />
    <path
      d="M22.5411 16.0015L23.4922 12.4317L20.1406 16.003L22.5411 16.0015Z"
      fill="#B68DFF"
    />
    <path
      d="M17.9656 16.0045L20.1406 16.0031L21.0947 12.5055L17.9656 16.0045Z"
      fill="#8A73FF"
    />
    <path
      d="M24.4453 9.16556L23.4926 12.4317L20.1409 16.003L21.095 12.5055L24.4453 9.16556Z"
      fill="#A180FF"
    />
    <path
      d="M21.1116 14.2341C21.4166 14.1646 21.6552 13.9243 21.7242 13.6206C21.7301 13.5971 21.7596 13.597 21.7655 13.6206C21.835 13.9256 22.0753 14.1642 22.3789 14.2332C22.4025 14.2391 22.4025 14.2686 22.3789 14.2745C22.074 14.344 21.8354 14.5843 21.7663 14.8879C21.7604 14.9115 21.731 14.9115 21.7251 14.888C21.6556 14.583 21.4152 14.3444 21.1116 14.2753C21.0895 14.2695 21.0895 14.2385 21.1116 14.2341ZM22.8936 12.5043C23.1322 12.4423 23.3207 12.2535 23.3825 12.0148C23.3884 11.9912 23.4193 11.9912 23.4267 12.0148C23.4887 12.2534 23.6775 12.4419 23.9162 12.5037C23.9398 12.5096 23.9398 12.5405 23.9163 12.5479C23.6776 12.6099 23.4891 12.7987 23.4274 13.0374C23.4215 13.061 23.3905 13.061 23.3831 13.0375C23.3211 12.7988 23.1323 12.6103 22.8936 12.5486C22.87 12.5412 22.87 12.5103 22.8936 12.5043Z"
      fill="white"
    />
    <path
      d="M7.54967 16.0002L7.55416 22.8349L8.50692 19.5687L9.45801 15.999L7.54967 16.0002Z"
      fill="#CB9AFF"
    />
    <path
      d="M11.8584 15.9974L8.50678 19.5687L9.45787 15.999L11.8584 15.9974Z"
      fill="#B68DFF"
    />
    <path
      d="M10.905 19.4949L11.8591 15.9974L14.0342 15.9959L10.905 19.4949Z"
      fill="#8A73FF"
    />
    <path
      d="M10.9043 19.4949L11.8584 15.9974L8.50678 19.5687L7.55402 22.8349L10.9043 19.4949Z"
      fill="#A180FF"
    />
    <path
      d="M5.64049 16.0015L6.59627 19.5699L7.55332 22.8349L7.54883 16.0002L5.64049 16.0015Z"
      fill="#B68DFF"
    />
    <path
      d="M3.24077 16.0031L6.59707 19.57L5.64129 16.0015L3.24077 16.0031Z"
      fill="#A180FF"
    />
    <path
      d="M4.19956 19.4993L3.24089 16.003L1.06582 16.0045L4.19956 19.4993Z"
      fill="#785EF7"
    />
    <path
      d="M4.19864 19.4993L3.23996 16.003L6.59627 19.5699L7.55332 22.8349L4.19864 19.4993Z"
      fill="#8A73FF"
    />
    <path
      d="M7.54928 16.0002L7.54479 9.16556L8.50184 12.4305L9.45761 15.999L7.54928 16.0002Z"
      fill="#EABFFF"
    />
    <path
      d="M9.45729 15.999L8.50151 12.4305L11.8578 15.9974L9.45729 15.999Z"
      fill="#CB9AFF"
    />
    <path
      d="M14.0335 15.996L11.8585 15.9974L10.8998 12.5011L14.0335 15.996Z"
      fill="#A180FF"
    />
    <path
      d="M7.54465 9.16555L8.5017 12.4305L11.858 15.9974L10.8993 12.5011L7.54465 9.16555Z"
      fill="#B68DFF"
    />
    <path
      d="M5.64107 16.0015L6.59216 12.4317L7.54492 9.16556L7.54941 16.0002L5.64107 16.0015Z"
      fill="#CB9AFF"
    />
    <path
      d="M5.64071 16.0015L6.5918 12.4317L3.24018 16.003L5.64071 16.0015Z"
      fill="#B68DFF"
    />
    <path
      d="M1.06519 16.0045L3.24025 16.0031L4.19434 12.5055L1.06519 16.0045Z"
      fill="#8A73FF"
    />
    <path
      d="M7.54492 9.16556L6.59216 12.4317L3.24054 16.003L4.19463 12.5055L7.54492 9.16556Z"
      fill="#A180FF"
    />
    <path
      d="M4.21121 14.2341C4.51621 14.1646 4.75478 13.9243 4.82384 13.6206C4.82972 13.5971 4.85919 13.597 4.8651 13.6206C4.93456 13.9256 5.17492 14.1642 5.47853 14.2332C5.50211 14.2391 5.50213 14.2686 5.47856 14.2745C5.17356 14.344 4.93499 14.5843 4.86593 14.8879C4.86005 14.9115 4.83058 14.9115 4.82467 14.888C4.75521 14.583 4.51485 14.3444 4.21124 14.2753C4.18913 14.2695 4.18911 14.2385 4.21121 14.2341ZM5.99316 12.5043C6.23185 12.4423 6.42035 12.2535 6.48208 12.0148C6.48796 11.9912 6.51891 11.9912 6.52629 12.0148C6.58834 12.2534 6.77709 12.4419 7.01585 12.5037C7.03943 12.5096 7.03945 12.5405 7.01588 12.5479C6.7772 12.6099 6.5887 12.7987 6.52696 13.0374C6.52108 13.061 6.49014 13.061 6.48275 13.0375C6.4207 12.7988 6.23196 12.6103 5.99319 12.5486C5.96961 12.5412 5.96959 12.5103 5.99316 12.5043Z"
      fill="white"
    />
    <defs>
      <clipPath id="clip0_1106_1161">
        <rect
          width="15.0899"
          height="15.0899"
          fill="white"
          transform="translate(8.4502 16.9007)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Icon;
